export enum PdfSettingsHeaderBlocksEnum {
  HEADER_INFO = 'HEADER_INFO',
  IMAGE = 'IMAGE',
  TEXT = 'TEXT',
  LOGO = 'LOGO',
}
